import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    src: String,
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: true },
  };

  async connect() {
    const lottie = (await import("lottie-web")).default;
    this.animation = lottie.loadAnimation({
      container: this.element,
      renderer: "svg",
      loop: this.loopValue,
      autoplay: this.autoplayValue,
      path: this.srcValue,
    });
  }

  disconnect() {
    if (this.animation) {
      this.animation.destroy();
    }
  }
}
